<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 14:12:42
 * @FilePath: \mrc-ess-fronted\src\Layout\components\Footer.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-05 09:53:47
-->
<template>
  <!-- <v-footer color="blue-grey" class="white--text" v-if="!hidden" fixed>
    <span>Vuetify</span>
    <v-spacer></v-spacer>
    <span>&copy; {{ new Date().getFullYear() }}</span>
  </v-footer> -->
  <v-sheet
    height="40"
    class="text-caption transparent flex-shrink-1 px-4 max-width"
    :class="
      contentClass +
      (left
        ? ' text-left'
        : center
        ? ' text-center'
        : right
        ? ' text-right'
        : ' text-center')
    "
    :style="{ color: fontColor, maxWidth: maxWidth }"
  >
    © {{ curYear }} {{ $t("label_essweb_footer_components_brandLabel") }}
    <span
      :class="linkReverse ? 'white--text' : 'primary--text'"
      style="cursor: pointer"
      @click="toText('https://privacy.essencehr.io/')"
      >{{ $t("label_essweb_footer_components_privacyPolicyLabel") }}</span
    >
    {{ $t("label_essweb_footer_components_andLabel") }}
    <span
      :class="linkReverse ? 'white--text' : 'primary--text'"
      style="cursor: pointer"
      @click="toText('https://terms.essencehr.io/')"
      >{{ $t("label_essweb_footer_components_termOfUseLabel") }}</span
    >
  </v-sheet>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "Footer",
  props: {
    left: { default: false, type: [Boolean, Number] },
    center: { default: true, type: [Boolean, Number] },
    right: { default: false, type: [Boolean, Number] },
    hidden: { default: false, type: [Boolean, Number] },
    linkReverse: { default: false, type: [Boolean, Number] },
    maxWidth: { default: "100%", type: String },
    fontColor: { default: "rgba(0, 0, 0, 0.38)", type: String },
    contentClass: { default: "ml-6 mr-6  pt-4 pb-0", type: String }, //mt-6 brain 830
  },
  data() {
    return {
      curYear: 2020,
    };
  },
  mounted() {
    // 更新年份
    this.curYear = dayjs(new Date()).format("YYYY").toString();
    // buglist 1382 mel
    // this.curYear =
    //   this.curYear +
    //   (dayjs(new Date())
    //     .format("YYYY")
    //     .toString() == this.curYear.toString()
    //     ? ""
    //     : " - " +
    //       dayjs(new Date())
    //         .format("YYYY")
    //         .toString());
  },
  methods: {
    toText(e) {
      window.location.href = e;
    },
  },
};
</script>
